module.exports = __webpack_public_path__ + "img/description-3.30b1553a.png";